
export class VendorBanksModelDto {
    id: number
    bankName: string
   


    constructor(

        id: number,
        bankName: string,
    ) {
        this.id = id
        this.bankName = bankName
        

    }

}

export class VendorBanksModelDtoReq {
    data:VendorBanksModelDto[]
    user:string
constructor(
    data:VendorBanksModelDto[],
    user:string
){
this.data = data
this.user = user
}}
